import { useNavigate } from 'react-router-dom'
import {
  Ticket,
  CalendarBlank,
  AddressBook,
  Heart,
  BookOpen,
  UserPlus,
} from '@phosphor-icons/react'

import KioskHeader from '../../components/KioskHeader/KioskHeader'
import { useLang } from '../../context/LangContext'

const CONTENT = {
  en: {
    eyebrow: 'Self-service kiosk',
    title: 'How can we help you today?',
    subtitle:
      'Select a module below to continue. The kiosk will return to this page automatically after inactivity.',

    modules: [
      {
        title: 'Submit Ticket',
        desc: 'Report maintenance, facilities, or support issues.',
        path: '/submit-ticket',
        icon: Ticket,
      },
      {
        title: 'Events',
        desc: 'View upcoming community events and activities.',
        path: '/events',
        icon: CalendarBlank,
      },
      {
        title: 'Contact Directory',
        desc: 'Find management, security, facilities, and key contacts.',
        path: '/directory',
        icon: AddressBook,
      },
      {
        title: 'Say Hi',
        desc: 'Share your message and photo with the community leader.',
        path: '/support-us',
        icon: Heart,
      },
      {
        title: 'Join PBB',
        desc: 'Register your interest to join PBB N22 Kedup.',
        path: '/join-pbb',
        icon: UserPlus,
      },
      {
        title: 'Resources',
        desc: 'Browse guides, information categories, and PDF downloads.',
        path: '/resources',
        icon: BookOpen,
      },
    ],
  },

  bm: {
    eyebrow: 'Kiosk layan diri',
    title: 'Bagaimana kami boleh membantu anda hari ini?',
    subtitle:
      'Pilih modul di bawah untuk teruskan. Kiosk akan kembali ke halaman utama secara automatik selepas tiada aktiviti.',

    modules: [
      {
        title: 'Hantar Aduan',
        desc: 'Laporkan penyelenggaraan, fasiliti, atau isu sokongan.',
        path: '/submit-ticket',
        icon: Ticket,
      },
      {
        title: 'Acara',
        desc: 'Lihat acara dan aktiviti komuniti yang akan datang.',
        path: '/events',
        icon: CalendarBlank,
      },
      {
        title: 'Direktori Kontak',
        desc: 'Cari pengurusan, keselamatan, fasiliti, dan kontak penting.',
        path: '/directory',
        icon: AddressBook,
      },
      {
        title: 'Say Hi',
        desc: 'Kongsi mesej dan gambar anda bersama pemimpin komuniti.',
        path: '/support-us',
        icon: Heart,
      },
      {
        title: 'Sertai PBB',
        desc: 'Daftar minat anda untuk menyertai PBB N22 Kedup.',
        path: '/join-pbb',
        icon: UserPlus,
      },
      {
        title: 'Sumber',
        desc: 'Lihat panduan, kategori maklumat, dan muat turun PDF.',
        path: '/resources',
        icon: BookOpen,
      },
    ],
  },
}

export default function KioskHomePage() {
  const navigate = useNavigate()
  const { lang } = useLang()

  const t = CONTENT[lang] || CONTENT.en

  return (
    <main className="kiosk-page">
      <div className="app-container kiosk-container">
        <KioskHeader />

        <section className="kiosk-hero">
          <span className="kiosk-hero__eyebrow">{t.eyebrow}</span>

          <h1>{t.title}</h1>

          <p>{t.subtitle}</p>
        </section>

        <section className="kiosk-module-grid">
          {t.modules.map((item) => {
            const Icon = item.icon

            return (
              <button
                key={item.path}
                type="button"
                className="kiosk-module-card"
                onClick={() => navigate(item.path)}
              >
                <span className="kiosk-module-card__icon">
                  <Icon size={34} />
                </span>

                <span>
                  <strong>{item.title}</strong>
                  <small>{item.desc}</small>
                </span>
              </button>
            )
          })}
        </section>
      </div>
    </main>
  )
}